import { render, staticRenderFns } from "./goodsTypeCell.vue?vue&type=template&id=cf50c24a&scoped=true"
import script from "./goodsTypeCell.vue?vue&type=script&lang=js"
export * from "./goodsTypeCell.vue?vue&type=script&lang=js"
import style0 from "./goodsTypeCell.vue?vue&type=style&index=0&id=cf50c24a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf50c24a",
  null
  
)

export default component.exports